// Global toast notifications (see Toast.svelte, rendered once in App.svelte).
// Used for things that happen off-screen or after the user has scrolled
// away — email backfill start/finish/error, sync-now, batch review actions —
// so the confirmation isn't missed. No existing notification component was
// found to reuse (searched frontend/src for "toast"/"Toast").
export type ToastKind = 'success' | 'error' | 'info';
export interface ToastAction {
  label: string;
  onClick: () => void;
}
export interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
  action?: ToastAction;
}

let items = $state<ToastItem[]>([]);
let nextId = 1;

function dismiss(id: number) {
  items = items.filter((i) => i.id !== id);
}

function push(text: string, kind: ToastKind = 'info', opts: { durationMs?: number; action?: ToastAction } = {}): number {
  const id = nextId++;
  items = [...items, { id, kind, text, action: opts.action }];
  const durationMs = opts.durationMs ?? 5000;
  if (durationMs > 0) setTimeout(() => dismiss(id), durationMs);
  return id;
}

export const toast = {
  get items() {
    return items;
  },
  push,
  dismiss,
  success: (text: string, action?: ToastAction) => push(text, 'success', { action }),
  error: (text: string) => push(text, 'error'),
  info: (text: string) => push(text, 'info')
};
